import React from 'react';
import { useFormikContext, Field } from 'formik';
import { H3 } from '../Tipografia/Texto';
import { DEVELOPMENT } from 'util/Dev';
import { FC } from 'react';


const FormikDebugImpl: React.FunctionComponent<any> = ({field, form, ...props}) => {
  const contexto = useFormikContext()
  
  return <>
    <details>
      <summary><H3>Formik Dev Tools</H3></summary>
      <pre
        style={{
          margin: 0,
          padding: 4,
          background: '#eee',
        }}
      >
        <b>props: </b>
        {stringify(contexto, 5, null, 2)}
      </pre>
    </details>
  </>
}

function stringify(val: any, depth: any, replacer: any, space: any) {
  depth = isNaN(+depth) ? 1 : depth;
  function _build(key: any, val: any, depth: any, o?: any, a?: any) { // (JSON.stringify() has it's own rules, which we respect here by using it for property iteration)
      return !val || typeof val != 'object' ? val : (a=Array.isArray(val), JSON.stringify(val, function(k,v){ if (a || depth > 0) { if (replacer) v=replacer(k,v); if (!k) return (a=Array.isArray(v),val=v); !o && (o=a?[]:{}); o[k] = _build(k, v, a?depth:depth-1); } }), o||(a?[]:{}));
  }
  return JSON.stringify(_build('', val, depth), null, space);
}

export const FormikDebug: FC = (props) => {
  return <>
    { DEVELOPMENT && <Field {...props} component={FormikDebugImpl} /> }
  </>
}